import { render, staticRenderFns } from "./Favorites_PostList.vue?vue&type=template&id=8aff6576&scoped=true&"
import script from "./Favorites_PostList.vue?vue&type=script&lang=js&"
export * from "./Favorites_PostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aff6576",
  null
  
)

export default component.exports